/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_persons_invitations_tab = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Invitaciones Enviadas (${i.count})`
};

const en_persons_invitations_tab = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Sent Invitations (${i.count})`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const persons_invitations_tab = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.persons_invitations_tab(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("persons_invitations_tab", locale)
	if (locale === "es") return es_persons_invitations_tab(inputs)
	return en_persons_invitations_tab(inputs)
};
export { persons_invitations_tab as "persons.invitations_tab" }